import { createAsyncThunk } from "@reduxjs/toolkit";
import { masterDataAPI } from "../api";

import { handleErrors } from "../../../api/errorUtils";
import type { GetGendersResponse, GetLanguagesResponse, GetProfileTypesResponse, GetSubjectsResponse } from "../ts";

export const GetAllMasterData = createAsyncThunk(
  "masterDataSlice/get_all",
  async (_, { dispatch }) => {
    await Promise.all([
      dispatch(GetSubjectsThunk()),
      dispatch(GetLanguagesThunk()),
      dispatch(GetGendersThunk()),
      dispatch(GetProfileTypesThunk()),
    ]);
  }
);

export const GetSubjectsThunk = createAsyncThunk<GetSubjectsResponse, void>(
  "masterDataSlice/get_subjects",
  async (_, thunkAPI) => {
    try {
      const response = await masterDataAPI.getSubjects();
      const { data } = response;
      return data;
    } catch (err: any) {
      return handleErrors(err, thunkAPI);
    }
  }
);

export const GetLanguagesThunk = createAsyncThunk<GetLanguagesResponse, void>(
  "masterDataSlice/get_languages",
  async (_, thunkAPI) => {
    try {
      const response = await masterDataAPI.getLanguages();
      const { data } = response;
      return data;
    } catch (err: any) {
      return handleErrors(err, thunkAPI);
    }
  }
);

export const GetGendersThunk = createAsyncThunk<GetGendersResponse, void>(
  "masterDataSlice/get_genders",
  async (_, thunkAPI) => {
    try {
      const response = await masterDataAPI.getGenders();
      const { data } = response;
      return data;
    } catch (err: any) {
      return handleErrors(err, thunkAPI);
    }
  }
);

export const GetProfileTypesThunk = createAsyncThunk<
  GetProfileTypesResponse,
  void
>("masterDataSlice/get_profile_types", async (_, thunkAPI) => {
  try {
    const response = await masterDataAPI.getProfileTypes();
    const { data } = response;
    return data;
  } catch (err: any) {
    return handleErrors(err, thunkAPI);
  }
});

const masterDataThunk = {
  GetSubjectsThunk,
  GetLanguagesThunk,
  GetGendersThunk,
  GetProfileTypesThunk,
  GetAllMasterData,
};

export default masterDataThunk;
